// Widget scripts
import cardWidget from './js/widgets/cardWidget.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import multiScheduleFeature from './js/widgets/multiScheduleFeature.js';
import seowidget from './js/widgets/seowidget.js';
import videoWidget from './js/widgets/videoWidget.js';
// Custom theme scripts
import './js/localjs.js';



// Initialize homepage widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    cardWidget(); 
    swiperWidget();  
    multiScheduleFeature();
    seowidget();
    videoWidget();
  });
}